/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Start_FirstInputs */

const en_us2_draft_start_first = /** @type {(inputs: Draft_Start_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with this plan`)
};

const pt_br2_draft_start_first = /** @type {(inputs: Draft_Start_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começar com este plano`)
};

const es_419_draft_start_first = /** @type {(inputs: Draft_Start_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empezar con este plan`)
};

const pt_pt2_draft_start_first = /** @type {(inputs: Draft_Start_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começar com este plano`)
};

const fr_fr2_draft_start_first = /** @type {(inputs: Draft_Start_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer ce programme`)
};

const de_de2_draft_start_first = /** @type {(inputs: Draft_Start_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit diesem Plan starten`)
};

const it_it2_draft_start_first = /** @type {(inputs: Draft_Start_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia con questa scheda`)
};

/**
* | output |
* | --- |
* | "Start with this plan" |
*
* @param {Draft_Start_FirstInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_start_first = /** @type {((inputs?: Draft_Start_FirstInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Start_FirstInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_start_first(inputs)
	if (locale === "es-419") return es_419_draft_start_first(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_start_first(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_start_first(inputs)
	if (locale === "de-DE") return de_de2_draft_start_first(inputs)
	if (locale === "it-IT") return it_it2_draft_start_first(inputs)
	return en_us2_draft_start_first(inputs)
});
export { draft_start_first as "draft.start_first" }